import { overflowHiddenStyle, overflowStyle } from './overflow';
export var circleContainerStyle = "\n  display: block;\n  position: relative;\n  border-radius: 50%;\n  " + overflowStyle + "\n  " + overflowHiddenStyle + "\n";